
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-plus",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-plus"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('path',{attrs:{"d":"M9 3.5v11M3.5 9h11"}})])])
          )
        }
      }
    